<template>
    <div class="login container">
        <div class="card">
            <div class="form-wrapper card-content">
                <form @submit.prevent="login">
                    <h2 class="title">Login</h2>
                    <div class="field">
                        <label for="email">Email:</label>
                        <input type="email" name="email" v-model="email">
                    </div>
                    <div class="field input last">
                        <label for="password">Password:</label>
                        <input type="password" name="password" v-model="password">
                    </div>
                    <p class="feedback error-light" v-if="feedback">{{ feedback }}</p>
                    <div class="field center">
                        <button class="btn">Login</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>



<script>
import firebase from 'firebase'

export default {
    name: 'Login',
    data() {
        return {
            email: null,
            password: null,
            feedback: null
        }
    },
    methods: {
        login() {
            if(this.email && this.password) {
                this.feedback = null

                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cred => {
                    this.$router.push({ name: 'Index' })
                })
                .catch(err => {
                    this.feedback = err.message
                })
            }
            else {
                this.feedback ="Please fill all fields"
            }
        }
    }
}

</script>



<style lang="scss">

    .login {
        max-width: 400px;
        margin-top: 60px;

        .title {
            font-size: 1.4em;
            color: #fff;
        }

        .field.input.last {
            margin-bottom: 40px;
        }

        .feedback {
            margin-bottom: 1rem !important;

            &.error-light {
                color: #c2f9ff;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue